import { ThemeBase } from './lib/ThemeBase';
import { ThemeMediaSize } from './defs/types';
import { initElements } from './lib/utils';
import { MeilisearchApi } from './MeilisearchApi';
import { browser } from './shared';
import { initGTMTracking } from './gtm';
import { createI18n } from 'vue-i18n';
import { initScrollForTables } from './content-rich/tables';
export function theme() {
    return Theme.instance;
}
export class Theme extends ThemeBase {
    constructor() {
        super(...arguments);
        this.MediaThreshold = {
            [ThemeMediaSize.XSmall]: {
                min: 0,
                max: 480,
            },
            [ThemeMediaSize.Small]: {
                min: 481,
                max: 600,
            },
            [ThemeMediaSize.MediumSmall]: {
                min: 601,
                max: 768,
            },
            [ThemeMediaSize.Medium]: {
                min: 769,
                max: 1024,
            },
            [ThemeMediaSize.MediumLarge]: {
                min: 1025,
                max: 1200,
            },
            [ThemeMediaSize.Large]: {
                min: 1201,
                max: 1600,
            },
            [ThemeMediaSize.XLarge]: {
                min: 1601,
                max: Infinity,
            }
        };
        this.meiliSearchApi = new MeilisearchApi(this.json.meilisearch.url, this.json.meilisearch.apiKey);
        this.i18n = createI18n({
            legacy: false,
            locale: this.json.i18n.locale,
            messages: {
                [this.json.i18n.locale]: this.json.i18n.strings,
            },
        });
        this._mediaSize = ThemeMediaSize.MediumLarge;
    }
    get mediaSize() {
        return this._mediaSize;
    }
    init() {
        if (browser.isSafari) {
            document.body.classList.add('is--safari');
        }
        initGTMTracking();
        initScrollForTables(document.body, '.richContent table');
        this.resolveCurrentMediaSize();
        window.addEventListener('load', () => this.resolveCurrentMediaSize());
        window.addEventListener('resize', () => this.resolveCurrentMediaSize());
        window.addEventListener('orientationchange', () => this.resolveCurrentMediaSize());
        this.fixWpBlockButtons();
        this.initRealViewportDimentions();
        this.forceExternalLinksToOpenInNewTab();
    }
    isPrintMode() {
        return document.body.classList.contains('is--printMode');
    }
    getUri(...paths) {
        return `/app/themes/custom-theme${paths ? '/' + paths.map(p => p.startsWith('/') ? p.substring(1) : p).join('/') : ''}`;
    }
    /**
     * Attach a listener to the theme:resize event.
     */
    attachBreakpointListener(listener) {
        document.documentElement.addEventListener('theme:breakpoint', listener);
    }
    /**
     * Remove a listener from the theme:resize event.
     */
    removeBreakpointListener(listener) {
        document.documentElement.removeEventListener('theme:breakpoint', listener);
    }
    resolveCurrentMediaSize() {
        const width = window.innerWidth;
        let media = null;
        for (let size of Object.keys(this.MediaThreshold)) {
            if (width <= this.MediaThreshold[size].max) {
                media = size;
                break;
            }
        }
        if (media && media !== this._mediaSize) {
            this._mediaSize = media;
            this.triggerBreakpointEvent();
        }
    }
    triggerBreakpointEvent() {
        const event = new CustomEvent('theme:breakpoint', {
            detail: {
                size: this._mediaSize,
                range: this.MediaThreshold[this._mediaSize],
                sizes: this.MediaThreshold,
            },
        });
        document.documentElement.dispatchEvent(event);
    }
    fixWpBlockButtons() {
        const siteContentEl = document.getElementById('siteContent');
        if (!siteContentEl) {
            return;
        }
        initElements({
            root: siteContentEl,
            selector: '.wp-element-button[href]',
        }, (el) => {
            const href = el.getAttribute('href');
            const matches = href === null || href === void 0 ? void 0 : href.match(/^https?:\/\/([^\/]+)/);
            if (matches) {
                const host = matches[1];
                if (host !== window.location.host) {
                    el.setAttribute('target', '_blank');
                    el.setAttribute('rel', 'noopener');
                    el.classList.add('is--external');
                }
            }
        });
    }
    forceExternalLinksToOpenInNewTab() {
        document.body.addEventListener('click', (e) => {
            const targetEl = e.target;
            const anchorEl = targetEl === null || targetEl === void 0 ? void 0 : targetEl.closest('a');
            if (anchorEl && anchorEl.href) {
                try {
                    const url = new URL(anchorEl.href);
                    if (url.host.replace('/^www./, ', '') !== window.location.host.replace('/^www./, ', '')) {
                        anchorEl.setAttribute('target', '_blank');
                    }
                }
                catch (err) {
                    console.warn(err);
                }
            }
        }, { capture: true });
    }
    initRealViewportDimentions() {
        var _a;
        const root = document.querySelector(':root');
        if (window.visualViewport && root) {
            const onViewportSizeUpdate = () => {
                var _a, _b;
                // This is a hack to get the real viewport size on mobile devices
                root.style.setProperty('--100vh', ((_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.height) + 'px');
                root.style.setProperty('--100vw', ((_b = window.visualViewport) === null || _b === void 0 ? void 0 : _b.width) + 'px');
            };
            onViewportSizeUpdate();
            (_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.addEventListener('resize', onViewportSizeUpdate);
        }
    }
}
